// extracted by mini-css-extract-plugin
export default {"table":"index_table_jHUQi","green":"index_green_qtCxI","more":"index_more_mGrRm"};